<div class="portlet light" style="min-height: 650px;">
  <storever-header-page [icon]="'fa-map-marker-alt fa-lg'"
                        [title]="'GENERIC_SITES'" >
  </storever-header-page>
  <br>
  <div class="portlet-body table-margin">
    <div class="row">
      <span class="col-sm-11 storever-filter-with-btn-container">
      <storever-sites-filter
        #filter
        [showSearchForm]="showFilter$ | async"
        [filter]="filter$ | async"
        [roles]="roles$ | async"
        [quickSearchField]="quickSearch$ | async"
        (toggle)="toggleFilter($event)"
        (search)="applyFilter($event)"
        (quickSearch)="applyQuickFilter($event)">
      </storever-sites-filter>
      </span>
      <span class="col-sm-1 btn-filter-container">
        <span   class="btn_import_excel" >
          <span>
             <span type="button" class="btn" (click)="exportAsXLSX()">
               <i class="fal fa-file-excel  fa-lg"></i> {{   'IMPORT_EXCEL_FILE' | translate:locale.language}}</span>
          </span>
        </span>
      </span>
    </div>
    <div class="row">
    <div class="table-responsive " style="margin: 0 15px;">
      <storever-datatable [striped]="true"
                          [hover]="true"
                          [data]="sites$ | async"
                          [count]="count$ | async"
                          [currentPage]="page$ | async"
                          [itemsPerPage]="pageSize$ | async"
                          [orderBy]="orderBy$ | async"
                          [menuItem]="mainMenuItem"
                          (pageChange)="pageChanged($event)"
                          (pageSizeChange)="pageSizeChanged($event)"
                          (orderByChange)="orderByChanged($event)"
                          (selectedAll)="selectAll($event)">
        <storever-datatable-column [name]="'checkBox'"
                                   [prop]="''">
          <ng-template let-row="row" let-value="value" storeverDatatableColumnCell>
           <span *ngIf="row.status !== 1" >
             <input type="checkbox" [checked]="checkAll" (click)="toggleSelected(row)" >
           </span>
            <span *ngIf="row.status === 1" tooltip="{{(row.status === 1) ?  ('SUBSCRIPTIONS_STATUS_OFF' | translate:locale.language) : null }}">
             <input type="checkbox"  [disabled]="(row.status === 1)">
           </span>
          </ng-template>
        </storever-datatable-column>
<!--        <storever-datatable-column [name]=""-->
<!--                                   [prop]="'displayName'"-->
<!--                                   [sortable]="false">-->
<!--          <ng-template let-row="row" let-value="value" storeverDatatableColumnCell>-->
<!--&lt;!&ndash;            <i class="far fa-file-plus"></i>&ndash;&gt;-->
<!--          </ng-template>-->
<!--        </storever-datatable-column>-->
        <storever-datatable-column [name]=""
                                   [prop]="'subscriptionCount'"
                                   [sortable]="false">
          <ng-template let-value="value" storeverDatatableColumnCell>
            <i class="far fa-map-marker-alt  fa-lg" *ngIf="value > 1"  tooltip="{{'Subscriptions count: ' + value}}"></i>
            <i class="fal fa-map-marker-alt fa-lg" *ngIf="value === 1"  tooltip="{{'Subscriptions count: ' + value}}"></i>
          </ng-template>
        </storever-datatable-column>
        <storever-datatable-column [name]="'GENERIC_NAME_LABEL' | translate:locale.language"
                                   [prop]="'displayName'"
                                   [sortable]="true">
          <ng-template let-row="row" let-value="value" storeverDatatableColumnCell>
            <a *ngIf="(row.subscriptionCount !== 1)" [routerLink]="['../', 'detail-multi', row.uuid]" fragment="Subscription"> {{value}} &nbsp; <i class="fal fa-sm fa-edit"></i></a>
            <a *ngIf="(row.subscriptionCount === 1)" [routerLink]="['../', 'detail', row.uuid]" fragment="Subscription"> {{value}} &nbsp; <i class="fal fa-sm fa-edit"></i></a>
          </ng-template>
        </storever-datatable-column>
        <storever-datatable-column [name]="'GENERIC_EXTERNAL_ID' | translate:locale.language"
                                   [prop]="'externalID'"
                                   [sortable]="true">
          <ng-template let-value="value" storeverDatatableColumnCell>
             {{value}}
          </ng-template>
        </storever-datatable-column>

<!--        <storever-datatable-column [name]="'GENERIC_STATUS' | translate:locale.language"-->
<!--                                   [prop]="'status'"-->
<!--                                   [sortable]="true" >-->
<!--          <ng-template let-value="value"  let-row="row" storeverDatatableColumnCell >-->
<!--            <span *ngIf="row.subscriptionCount === 1">-->
<!--              <i *ngIf="value === 3"-->
<!--                 class="fa fa-fw fa-flag text-success"-->
<!--                 aria-hidden="true"-->
<!--                 tooltip="{{'SUBSCRIPTIONS_STATUS_EXPLOIT' | translate:locale.language}}"></i>-->
<!--              <i *ngIf="value === 2"-->
<!--                 class="fa fa-fw fa-flask text-info"-->
<!--                 aria-hidden="true"-->
<!--                 tooltip="{{'SUBSCRIPTIONS_STATUS_DEMO' | translate:locale.language}}"></i>-->
<!--              <i *ngIf="value === 1"-->
<!--                 class="fa fa-fw fa-power-off text-danger"-->
<!--                 aria-hidden="true"-->
<!--                 tooltip="{{'SUBSCRIPTIONS_STATUS_OFF' | translate:locale.language}}"></i>-->
<!--              <i *ngIf="value === 0"-->
<!--                 class="fa fa-fw fa-flag-checkered text-warning"-->
<!--                 aria-hidden="true"-->
<!--                 tooltip="{{'SUBSCRIPTIONS_STATUS_TO_OFF' | translate:locale.language}}"></i>-->
<!--              <i *ngIf="value === -1"-->
<!--                 class="fa fa-fw fa-stop text-danger"-->
<!--                 aria-hidden="true"-->
<!--                 tooltip="{{'SUBSCRIPTIONS_STATUS_STOP' | translate:locale.language}}"></i>-->
<!--              <i *ngIf="value === -2"-->
<!--                 class="fas fa-university text-danger"-->
<!--                 aria-hidden="true"-->
<!--                 tooltip="{{'SUBSCRIPTIONS_STATUS_BANKRUPTCY' | translate:locale.language}}"></i>-->
<!--            </span>-->
<!--          </ng-template>-->


<!--        </storever-datatable-column>-->
        <storever-datatable-column [name]=""
                                   [prop]="'country'"
                                   [sortable]="false">
          <ng-template let-value="value" let-row="row" storeverDatatableColumnCell>
            <div *ngIf="row && row['addresses']" tooltip="{{getAddressesAtIndexByType(row, 0, 'country')}}"
                  class="famfamfam-flags {{getAddressesAtIndexByType(row, 0, 'countryCode')}}"></div>
          </ng-template>
        </storever-datatable-column>
        <storever-datatable-column [name]="'GENERIC_ADDRESS' | translate:locale.language"
                                   [prop]="'Address_Line1'"
                                   [sortable]="true">
          <ng-template let-value="value" let-row="row" storeverDatatableColumnCell>
            <span *ngIf="row && row['addresses']">{{getAddressesAtIndexByType(row, 0, 'line1')}}</span>
          </ng-template>
        </storever-datatable-column>
        <storever-datatable-column [name]="'GENERIC_ZIP' | translate:locale.language"
                                   [prop]="'Address_Zip'"
                                   [sortable]="true">
          <ng-template let-value="value" let-row="row" storeverDatatableColumnCell>
            <span *ngIf="row && row['addresses']">{{getAddressesAtIndexByType(row, 0, 'zip')}}</span>
          </ng-template>
        </storever-datatable-column>
        <storever-datatable-column [name]="'GENERIC_CITY' | translate:locale.language"
                                   [prop]="'Address_City'"
                                   [sortable]="true">
          <ng-template let-value="value" let-row="row" storeverDatatableColumnCell>
            <span *ngIf="row && row['addresses']">{{getAddressesAtIndexByType(row, 0, 'city')}}</span>
          </ng-template>
        </storever-datatable-column>
        <storever-datatable-column *ngIf="isInRole$('BO_BILLING_VIEW') | async"
                                   [name]="'GENERIC_COMPANY' | translate:locale.language"
                                   [prop]="'companyName'"
                                   [sortable]="true">
          <ng-template let-row="row" let-value="value" storeverDatatableColumnCell>
            <a *ngIf="row.companyUuid"  [routerLink]="['/', 'companies','detail', row.companyUuid]"> {{value}} &nbsp;</a>
          </ng-template>
        </storever-datatable-column>
        <storever-datatable-column [name]="menuTitle"
                                   [prop]="''">
          <ng-template let-value="value" let-row="row" storeverDatatableColumnCell>
            <storever-contextual-menu-container [menuItem]="createMenuContextual(row)"
                                                [tooltipPlacement]="'top'"
            ></storever-contextual-menu-container>
          </ng-template>
        </storever-datatable-column>
      </storever-datatable>
    </div>
    </div>
  </div>
</div>
<storever-merge-client-dialog #mergeClientModal
                              [selectedItems]="(selectedItem$ | async)"
                              [currentClientUuid]="storeCurrentClient"
                              (saveForm)="mergeSiteOfClient($event)" >
</storever-merge-client-dialog>

<!--<storever-modal-bulk-status-off-to-off #bulkUpdateModal-->
<!--                              [selectedItems]="(selectedItem$ | async)"-->
<!--                              (bulkUpdate)="bulkUpdateStatus($event)" >-->
<!--</storever-modal-bulk-status-off-to-off>-->
